export default __webpack_public_path__ + "static/media/chart-presentation-report-svgrepo-com.d44dac92.svg";